import merge from '~lodash.mergewith'
import * as CoreSdk from '~@sentry/core'
import { captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } from '~@sentry/browser'
import { extraErrorDataIntegration, reportingObserverIntegration } from '~@sentry/integrations'
import { init, browserTracingIntegration } from '~@sentry/vue'

export { init }
export const SentrySdk = { ...CoreSdk, ...{ captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } }

/** @type {string[]} */
const DISABLED_INTEGRATION_KEYS = []

/**
 * @typedef {Parameters<typeof init>[0]} InitConfig
 * @param {import('@nuxt/types').Context} ctx
 * @return {Promise<InitConfig>}
 */
export function getConfig (ctx) {
  /** @type {InitConfig} */
  const config = {
    dsn:true,
    environment:"production",
    ignoreErrors:[new RegExp(".*Cannot read properties of undefined \\(reading 'bind'\\).*", "gi"),new RegExp(".*undefined is not an object \\(evaluating 'this\\.updateVisibleFocusableElements\\.bind'\\).*", "gi")],
    beforeSend:function(event, hint) {
        try {
          const error = hint?.originalException;

          const filters = [
          /.*Cannot read properties of undefined \(reading 'bind'\).*/gi,
          /.*undefined is not an object \(evaluating 'this\.updateVisibleFocusableElements\.bind'\).*/gi];

          if (error && error.message && typeof error.message === 'string') {
            if (filters.find((filter) => error.message.match(filter))) {
              console.log(
                'Sentry: Ignoring error due to filter match:',
                error.message
              );
              return null;
            }
          }

          if (
          event?.exception?.values?.[0]?.stacktrace?.frames?.[0]?.abs_path ===
          'https://bat.bing.com/bat.js')
          {
            return null;
          }
          return event;
        } catch (e) {
          console.error('Error in Sentry beforeSend:', e);
          return null;
        }
      },
    tracesSampleRate:0.1,
  }

  /** @type {NonNullable<InitConfig>['integrations']} */
  const resolvedIntegrations = [
    extraErrorDataIntegration(),
    reportingObserverIntegration({ types:["crash","crash"] }),
  ]

  resolvedIntegrations.push(browserTracingIntegration({
    router: ctx.app.router,
    ...{"routeLabel":"name"},
    ...{"enableInp":true},
  }))
  merge(config, {"trackComponents":true,"tracing":true,"tracingOptions":{"hooks":["mount"],"timeout":2000,"trackComponents":false}}, {"tracesSampleRate":0.1})

  config.integrations = (defaultIntegrations) => {
    return [
      ...defaultIntegrations.filter(integration => !DISABLED_INTEGRATION_KEYS.includes(integration.name)),
      ...resolvedIntegrations,
    ]
  }
  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
